import { isDefinedString, isPositiveNumber, reduce } from "et3-type-guards";
import i18n from "../../../../../../../constants/i18n";
import getKhattabatStore from "../../../../../../../stores/khattabat-stores";
import { TalkhattabatConversationType } from "../../../../../../../Types";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";

const CreateOneOTwoButton = withLiteObserverAndTheme<{
  conversationID: string;
  conversationType: TalkhattabatConversationType;
  alkhattabaUUID: string;
  userUUID: string;
  isValidSubscription: boolean;
  userID: number;
  oneOOneCId: string
}>((props) => {
  const {
    theme,
    conversationType,
    alkhattabaUUID,
    userUUID,
    conversationID,
    isValidSubscription,
    userID,
    oneOOneCId
  } = props;
  const { unitX, colors } = theme;
  const isOneOOneCConversation = conversationType === "101C";
  const shouldShow = isOneOOneCConversation;
  const matchUserId = reduce(
    () =>
      getKhattabatStore().conversationsProps.get(conversationID)
        .insertUserIdField,
    -1
  );
  const isDisabledButton =
    !isDefinedString(alkhattabaUUID) ||
    !isDefinedString(userUUID) ||
    !isPositiveNumber(matchUserId) ||
    !isValidSubscription;

  return shouldShow ? (
    <ET3Div
      width={180}
      height={43}
      alignItems={"center"}
      fDirection={"column"}
      style={{
        borderRadius: 36 * unitX,
        cursor: isValidSubscription ? "pointer" : "unset",
        overflow: "hidden",
        backgroundColor: isDisabledButton
          ? colors.all.davysGrey
          : colors.all.bondiBlue
      }}
      color={""}
      justifyContent={"center"}
      withShadow={true}
      isExtendable={false}
      isScrollable={false}
      onClick={
        isDisabledButton
          ? null
          : () =>
            getKhattabatStore().createOneOTwo({
              alkhattabaUUID,
              userUUID,
              userID,
              matchUserId,
              conversationID,
              oneOOneCId
            })
      }
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={24}
        isSpan={false}
        text={i18n.get("CREATE_ONE_O_TWO")}
        style={{}}
        color={colors.all.white}
      />
    </ET3Div>
  ) : null;
});

export default CreateOneOTwoButton;
